var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataNot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 663,
    height: 440,
    viewBox: "0 0 663 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504.454 23.2372H602.977",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4883 8.63281H94.872",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M553.931 87.6688H615.884",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M562.104 374.604H624.058",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3027 372.456H83.2562",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161.128 15.935C165.168 15.935 168.442 12.6657 168.442 8.6328C168.442 4.59989 165.168 1.33057 161.128 1.33057C157.089 1.33057 153.814 4.59989 153.814 8.6328C153.814 12.6657 157.089 15.935 161.128 15.935Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M265.244 387.919C265.244 391.785 261.802 395.222 257.93 395.222C254.058 395.222 250.616 391.785 250.616 387.919C250.616 384.054 254.058 380.617 257.93 380.617C261.802 380.617 265.244 384.054 265.244 387.919Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M591.791 137.496C591.791 141.362 588.349 144.798 584.477 144.798C580.605 144.798 577.163 141.362 577.163 137.496C577.163 133.63 580.605 130.194 584.477 130.194C588.779 130.194 591.791 133.63 591.791 137.496Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M631.372 418.417C631.372 422.283 627.93 425.719 624.058 425.719C620.186 425.719 616.744 422.283 616.744 418.417C616.744 414.551 620.186 411.115 624.058 411.115C627.93 411.544 631.372 414.551 631.372 418.417Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M544.465 439.465C548.505 439.465 551.779 436.195 551.779 432.162C551.779 428.13 548.505 424.86 544.465 424.86C540.426 424.86 537.151 428.13 537.151 432.162C537.151 436.195 540.426 439.465 544.465 439.465Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M642.989 25.8145L643.419 39.1304",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M643.419 51.1576L643.849 64.0439",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M662.349 44.7144H649.442",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M637.396 45.144L624.059 45.5735",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M656.757 31.3986L647.722 40.8485",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M639.117 49.4394L630.082 58.8893",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M657.187 58.4598L647.722 49.0098",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M639.116 40.8485L629.651 31.8281",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.035 57.6007L100.465 70.487",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100.465 82.5142L100.895 95.8301",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.395 76.071L106.488 76.5006",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4417 76.9302H81.1045",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M113.802 62.7552L104.768 72.2052",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1628 80.796L87.1279 90.246",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M114.233 89.8164L104.768 80.796",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1624 72.6347L86.6973 63.6143",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5586 393.933V406.819",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9883 418.847V432.162",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.919 412.403L94.0117 412.833",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9651 413.263H68.6279",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M100.895 399.088L91.8604 408.538",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6862 417.128L74.6514 426.578",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.756 426.149L92.291 417.128",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6858 408.967L74.2207 399.517",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0.651367 106.139H44.1049",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M484.124 321.779H191.367C189.932 321.779 188.736 320.583 188.736 319.148V143.111C188.736 133.783 196.151 126.369 205.479 126.369H470.252C479.58 126.369 486.994 133.783 486.994 143.111V318.909C486.755 320.583 485.559 321.779 484.124 321.779Z",
    fill: "#F2F2F2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M191.366 329.911C185.387 329.911 179.646 325.128 179.646 319.148V143.111C179.646 129.239 191.605 119.193 205.478 119.193H470.251C484.123 119.193 495.365 129.239 495.365 143.111V318.909C495.365 324.888 490.342 329.672 484.362 329.672H191.366V329.911Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M470.012 126.608H205.239C195.911 126.608 188.975 134.023 188.975 143.351V319.148C188.975 320.583 189.692 322.736 191.127 322.736H483.884C485.319 322.736 487.711 320.583 487.711 319.148V143.111C487.95 134.023 479.34 126.608 470.012 126.608ZM480.775 317.952H193.758V143.351C193.758 137.132 199.02 133.783 205.239 133.783H470.012C476.23 133.783 480.775 137.132 480.775 143.351V317.952Z",
    fill: "#091B21"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M466.185 303.841H209.305C207.87 303.841 206.674 302.645 206.674 301.21V147.177C206.674 145.742 207.87 144.546 209.305 144.546H465.945C467.38 144.546 468.576 145.742 468.576 147.177V300.97C468.815 302.405 467.62 303.841 466.185 303.841Z",
    fill: "#F2F2F2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M484.123 348.567H191.366C180.125 348.567 171.036 341.392 171.036 332.303V318.909C171.036 317.474 172.232 316.278 173.667 316.278H501.823C503.258 316.278 504.454 317.474 504.454 318.909V332.303C504.454 341.392 495.365 348.567 484.123 348.567ZM176.298 321.779V332.542C176.298 338.282 183.234 343.305 191.127 343.305H483.884C492.016 343.305 498.713 338.282 498.713 332.542V321.779H176.298Z",
    fill: "#091B21"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M246.857 278.009C232.745 262.701 208.827 261.984 193.52 276.096C178.212 290.207 177.495 314.125 191.606 329.433C205.718 344.74 229.636 345.458 244.944 331.346C260.251 316.995 261.208 293.077 246.857 278.009ZM238.486 324.171C227.244 334.695 209.306 334.216 198.782 322.736C188.258 311.494 188.736 293.556 200.217 283.032C211.458 272.508 229.397 272.986 239.921 284.467C250.445 295.948 249.727 313.647 238.486 324.171Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M249.695 303.631C249.904 287.12 236.69 273.566 220.18 273.356C203.67 273.146 190.115 286.36 189.905 302.871C189.696 319.381 202.91 332.935 219.42 333.145C235.93 333.355 249.485 320.141 249.695 303.631Z",
    fill: "#F2F2F2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M200.456 305.276C202.173 305.276 203.565 303.883 203.565 302.166C203.565 300.449 202.173 299.057 200.456 299.057C198.739 299.057 197.347 300.449 197.347 302.166C197.347 303.883 198.739 305.276 200.456 305.276Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M245.422 278.248C231.549 264.137 209.066 263.897 194.715 277.531C180.604 291.403 180.365 313.886 193.998 328.237C207.87 342.349 230.353 342.588 244.704 328.954C258.816 315.082 259.055 292.599 245.422 278.248ZM198.303 324.171C186.822 312.212 187.062 293.317 198.781 281.836C210.74 270.355 229.636 270.594 241.116 282.314C252.597 294.273 252.358 313.169 240.638 324.649C228.918 336.369 209.784 336.13 198.303 324.171Z",
    fill: "#091B21"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M151.424 369.854C148.075 366.506 148.075 360.765 151.663 357.417L177.494 332.303L189.693 344.74L163.861 369.854C160.513 373.442 155.011 373.203 151.424 369.854Z",
    fill: "#091B21"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M184.909 343.305L178.93 337.087C176.299 334.456 176.538 330.39 178.93 327.759L181.082 325.606C183.713 322.975 187.779 323.214 190.41 325.606L196.39 331.825C199.021 334.456 198.781 338.522 196.39 341.153L194.237 343.305C191.606 345.936 187.54 345.697 184.909 343.305Z",
    fill: "#FFFFFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_593_2568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.84 82.4634H378.16V167.228H437.931L438.623 190.989L460.069 167.228H519.84V82.4634Z",
    fill: "#F2F2F2",
    stroke: "#091B21",
    strokeWidth: 2.4888,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.216 136.796V108.726H419.115V113.034H411.367V120.677H417.039V124.984H411.367V132.627H419.115V136.935H407.216V136.796Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.661 108.865C431.013 108.865 432.673 109.56 433.78 110.811C434.749 111.922 435.164 113.451 435.164 115.535V119.565C435.164 121.511 434.472 123.178 432.95 124.568L435.994 136.796H431.428L429.076 126.235C428.938 126.235 428.799 126.235 428.661 126.235H426.309V136.796H422.158V108.865H428.661ZM431.152 115.535C431.152 113.868 430.321 113.034 428.799 113.034H426.309V121.927H428.799C429.491 121.927 430.045 121.649 430.46 121.233C430.875 120.816 431.152 120.121 431.152 119.565V115.535Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.371 108.865C448.723 108.865 450.384 109.56 451.491 110.811C452.459 111.922 452.874 113.451 452.874 115.535V119.565C452.874 121.511 452.182 123.178 450.66 124.568L453.704 136.796H449.139L446.648 126.235C446.51 126.235 446.371 126.235 446.233 126.235H443.743V136.796H439.592V108.865H446.371ZM448.862 115.535C448.862 113.868 448.032 113.034 446.51 113.034H444.019V121.927H446.51C447.202 121.927 447.755 121.649 448.17 121.233C448.585 120.816 448.862 120.121 448.862 119.565V115.535Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.389 108.448C465.188 108.448 466.848 109.143 468.093 110.394C469.339 111.645 470.03 113.312 470.03 115.118V130.404C470.03 132.21 469.339 133.878 468.093 135.128C466.848 136.379 465.188 137.074 463.389 137.074C461.591 137.074 459.93 136.379 458.685 135.128C457.44 133.878 456.748 132.21 456.748 130.404V115.118C456.748 113.312 457.44 111.645 458.685 110.394C460.069 109.143 461.591 108.448 463.389 108.448ZM465.741 115.118C465.741 114.424 465.465 113.868 465.05 113.451C464.634 113.034 464.081 112.756 463.389 112.756C462.697 112.756 462.144 113.034 461.729 113.451C461.314 113.868 461.037 114.424 461.037 115.118V130.404C461.037 131.099 461.314 131.654 461.729 132.071C462.144 132.488 462.836 132.766 463.389 132.766C464.081 132.766 464.634 132.488 465.05 132.071C465.465 131.654 465.741 131.099 465.741 130.404V115.118Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.408 108.865C482.76 108.865 484.42 109.56 485.527 110.811C486.495 111.922 486.91 113.451 486.91 115.535V119.565C486.91 121.511 486.219 123.178 484.697 124.568L487.741 136.796H483.175L480.684 126.235C480.546 126.235 480.408 126.235 480.269 126.235H477.779V136.796H473.628V108.865H480.408ZM482.898 115.535C482.898 113.868 482.068 113.034 480.546 113.034H478.055V121.927H480.546C481.238 121.927 481.791 121.649 482.206 121.233C482.621 120.816 482.898 120.121 482.898 119.565V115.535Z",
    fill: "#091B21"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_593_2568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.803 225.571C268.438 224.206 268.438 221.978 269.803 220.613L296.591 193.826C297.956 192.461 300.183 192.461 301.548 193.826C302.913 195.191 302.913 197.418 301.548 198.783L274.761 225.571C273.396 226.948 271.168 226.948 269.803 225.571Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.547 225.571C302.913 224.205 302.913 221.978 301.547 220.613L274.76 193.826C273.395 192.448 271.167 192.448 269.802 193.826C268.425 195.191 268.425 197.418 269.802 198.783L296.59 225.571C297.955 226.948 300.182 226.948 301.547 225.571Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.144 225.571C373.779 224.206 373.779 221.978 375.144 220.613L401.931 193.826C403.297 192.461 405.524 192.461 406.889 193.826C408.254 195.191 408.254 197.418 406.889 198.783L380.102 225.571C378.736 226.948 376.509 226.948 375.144 225.571Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.889 225.571C408.254 224.206 408.254 221.978 406.889 220.613L380.102 193.826C378.736 192.461 376.509 192.461 375.144 193.826C373.779 195.191 373.779 197.418 375.144 198.783L401.931 225.571C403.297 226.948 405.524 226.948 406.889 225.571Z",
    fill: "#091B21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.612 274.727C364.307 274.727 363.05 274.009 362.415 272.775C357.685 263.555 347.974 257.663 337.699 257.771C327.64 257.879 318.444 263.507 313.702 272.464C312.78 274.212 310.6 274.883 308.852 273.961C307.104 273.039 306.433 270.859 307.355 269.111C313.331 257.819 324.922 250.718 337.627 250.586C344.046 250.526 350.357 252.25 355.877 255.603C361.397 258.944 365.864 263.758 368.81 269.494C369.72 271.254 369.013 273.422 367.253 274.332C366.714 274.595 366.163 274.727 365.612 274.727Z",
    fill: "#091B21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_593_2568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 112,
    fill: "white",
    transform: "translate(376.5 80.7959)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_593_2568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 139.146,
    height: 81.9312,
    fill: "white",
    transform: "translate(268.772 192.796)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataNot);
export default __webpack_public_path__ + "static/media/DataNot.e61cb868063b2640e1e36e5fb4c0bdca.svg";
export { ForwardRef as ReactComponent };